import {Component} from '@angular/core';
import {SupplierService} from "../../_services/_dto-services/supplier.service";
import {PopupBase} from "../../../../_abstracts/popup-base";
import {SupplierDto} from "../../x-models/supplier-dto";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-supplier-popup',
  templateUrl: './supplier-popup.component.html',
  imports: [
    CommonModule
  ],
  styleUrls: ['./supplier-popup.component.scss']
})
export class SupplierPopupComponent extends PopupBase<SupplierDto> {
  constructor(public SupplierService: SupplierService) {
    super();
  }
}
